module.exports = __webpack_public_path__ + "home/img/upload.cc84ae29.svg";